import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/shared/services/user.service';

@Pipe({ name: 'isUserInRole' })
export class IsUserInRolePipe implements PipeTransform {
  public constructor(private _userService: UserService) {}

  transform(role: string): Observable<boolean> {
    return this._userService.getUser().pipe(map(user => user.roles.filter(r => r.name === role).length > 0));
  }
}
